import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VMS_Notification } from 'src/app/model/notification.model';
import { NotificationService } from 'src/app/services/notification.service';


@Component({
  selector: 'app-view-notification',
  templateUrl: './view-notification.component.html',
  styleUrls: ['./view-notification.component.css']
})
export class ViewNotificationComponent implements OnInit {

  model: VMS_Notification;
  today: any = new Date();
  minSDate: string = this.today.getFullYear() + '-' + (this.today.getMonth() + 1) + '-' + this.today.getDate();
  minEDate: string = this.minSDate;
  dataId: string;
  downloadBaseURL :string;
  constructor(private toastr: ToastrService, private notificationSer: NotificationService, 
    private route: ActivatedRoute,private router: Router) {
      this.model=new VMS_Notification();
    this.downloadBaseURL = this.notificationSer.GetDownloadBaseURL();
    this.route.queryParams.subscribe(params => { this.dataId = params['id']; });
    console.log('dataID', Number(this.dataId));
   

  }



  ngOnInit() {
    let id = 1;
    if (this.dataId != undefined && this.dataId != null && this.dataId != '' && Number(this.dataId) > 0) {
      this.GetNotification(Number(this.dataId));
    }

    //this.GetNotification(id);


    //(<HTMLInputElement>document.getElementById("START_DATE")).min =  today.getFullYear() +'-'+(today.getMonth()+1) +'-'+today.getDate();


  }

  finalUploadedFile:string='';
  GetNotification(id: number) {
    this.notificationSer.GetNotification(id).subscribe(
      res => {
        console.log(res);
        this.model = res.Data;
        this.finalUploadedFile = this.CheckAttachmentName(this.model.ATTACHMENTS);
      },
      error => {
        console.log(error);
      }
    );
  }


  SaveNotification(action) {

    console.log(this.model);
    this.model.STATUS = action;

    this.notificationSer.SaveNotification(this.model).subscribe(
      res => {
        console.log(res);
        if (res.Status) {
          this.toastr.success("Notification is created successfully.", "Success");
          this.model = new VMS_Notification();
        }
        else {
          this.toastr.warning(res.Message, "Error");
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  
  GoToEdit(id: number) {
    this.router.navigate(['/notification'], { queryParams: { id: id }, replaceUrl: true });
  }

  // ************ Change Events  ***********************

  ChangeStartDate(event) {
    this.model.START_DATE = event;
    let sDate = new Date(this.model.START_DATE);
    console.log(sDate);
    this.minEDate =  sDate.getFullYear() + '-' + (sDate.getMonth() + 1) + '-' + sDate.getDate();
    this.model.END_DATE = null;
    //this.model.END_DATE = new Date(sDate.setMonth(sDate.getMonth() + 2));
  }

  CheckAttachmentName(attachName): string {

    if (this.model.ATTACHMENTS == '' || this.model.ATTACHMENTS == undefined || this.model.ATTACHMENTS == null) {
      return '';
    }
    else {
      let li = this.model.ATTACHMENTS.indexOf('.');
      let fname = this.model.ATTACHMENTS.substring(0, (li - 15));
      const pattern = /_/gi;
      const replacement = " ";
      return fname;
      // return fname.replace(pattern, replacement);
    }
  }

}


